import {Component, Input} from '@angular/core';

@Component({
    selector: 'form-row',
    template: `
    <label *ngIf="label" class="label">{{ label }}</label>
    <ng-content></ng-content>
  `,
    styles: [
        `
      :host {
        display: flex;
        width: 100%;
      }
    `,
    ],
    standalone: false
})
export class UiFormsFormRowComponent {
  @Input() public label: string | undefined;
}
